/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CaseOwnerResponseAccountInformation
 */
export interface CaseOwnerResponseAccountInformation {
    /**
     * Account number - 8 digits with leading zeros (0) if less than 8 digits
     * @type {string}
     * @memberof CaseOwnerResponseAccountInformation
     */
    accountNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseOwnerResponseAccountInformation
     */
    accountName?: string;
}

/**
 * Check if a given object implements the CaseOwnerResponseAccountInformation interface.
 */
export function instanceOfCaseOwnerResponseAccountInformation(value: object): value is CaseOwnerResponseAccountInformation {
    return true;
}

export function CaseOwnerResponseAccountInformationFromJSON(json: any): CaseOwnerResponseAccountInformation {
    return CaseOwnerResponseAccountInformationFromJSONTyped(json, false);
}

export function CaseOwnerResponseAccountInformationFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaseOwnerResponseAccountInformation {
    if (json == null) {
        return json;
    }
    return {
        
        'accountNumber': json['accountNumber'] == null ? undefined : json['accountNumber'],
        'accountName': json['accountName'] == null ? undefined : json['accountName'],
    };
}

export function CaseOwnerResponseAccountInformationToJSON(json: any): CaseOwnerResponseAccountInformation {
    return CaseOwnerResponseAccountInformationToJSONTyped(json, false);
}

export function CaseOwnerResponseAccountInformationToJSONTyped(value?: CaseOwnerResponseAccountInformation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'accountNumber': value['accountNumber'],
        'accountName': value['accountName'],
    };
}

